// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new-message-form__advancedinput[data-v-c94b294e]{overflow:visible;width:100%;border:none;margin:0;word-break:break-word;white-space:pre-wrap}div[contenteditable][data-v-c94b294e]{font-size:14px}[contenteditable][data-v-c94b294e]:empty:before{content:attr(placeholder);display:block;color:var(--color-text-maxcontrast)}\n", ""]);
// Exports
module.exports = exports;
